import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

export default function LazyPieChart({ data, colors }) {
  return (
    <ResponsiveContainer width={80} height={80}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          innerRadius={22}
          outerRadius={36}
          paddingAngle={2}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={colors[i % colors.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
}
